










































































import { Component, Prop } from "vue-property-decorator";
import { FileagentConfiguration } from "./fileagentConfiguration";
import WidgetBase from "../WidgetBase.vue";
import VueFileAgentPlugin, { FileRecord } from "vue-file-agent";
import { VueFileAgentComponent } from "../../../interfaces/vueFileAgent";
import ConfirmDeleteDialog from "@/components/customActions/ConfirmDeleteDialog.vue";

@Component({
    components: {
        "vue-file-agent": VueFileAgentPlugin.VueFileAgent,
        ConfirmDeleteDialog,
    },
})
export default class FileagentWidget extends WidgetBase<
    FileagentConfiguration
> {
    @Prop() widgetHeight!: number;

    public token: { Authorization: string } = { Authorization: "" };
    public fileRecordsForUpload: FileRecord[] = [];
    public deleteDialogActive: boolean = false;
    public fileRecordToDelete: FileRecord | null = null;
    public static get type() {
        return "fileagent";
    }

    public reportDownloadedFile(e: Event) {
        const url: string | null = this.getHref(e);

        if (!url) return;
        const fileId: string | undefined = url.split("/").pop();

        if (!fileId) return;

        const file: FileRecord | undefined = this.config.state.fileRecords.find(
            x => x.upload.data.id == fileId
        );

        this.update({
            config: this.config,
            payload: {
                reportedDownload: {
                    filename: file?.name() || "",
                    userName: this.$store.state.user.id,
                },
            },
        });
    }

    public getHref(e: Event) {
        const traverse = (x: HTMLBaseElement): string =>
            !x.href && x.parentNode
                ? traverse(x.parentNode as HTMLBaseElement)
                : x.href;

        return traverse(e.srcElement as HTMLBaseElement);
    }
    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/upload.svg");
    }
    public async mounted() {
        if (this.$auth.isAuthenticated) {
            this.token = await this.$auth.getTokenSilently();
        }
    }

    public get label() {
        return this.$t("widget.fileAgent.layoutList");
    }

    public get uploadHeaders() {
        return { Authorization: `Bearer ${this.token}` };
    }

    public get uploadUrl(): string {
        return "/api/file/by_id/" + this.config.widgetId;
    }

    public get downloads() {
        return this.config.state.report.length;
    }

    public get fileRecords(): FileRecord[] {
        return this.cleanFileRecords(this.config.state.fileRecords);
    }
    public set fileRecords(newVal) {
        this.config.state.fileRecords = newVal;
    }

    public get themeToggle(): boolean {
        return this.config.state.themeToggle || false;
    }

    public set themeToggle(newVal) {
        this.config.state.themeToggle = newVal;
        this.update({
            config: this.config,
            payload: { themeToggle: newVal },
        });
    }

    public get guestUpload(): boolean {
        return this.config.state.guestUpload;
    }

    public set guestUpload(newVal) {
        this.config.state.guestUpload = newVal;
        this.update({
            config: this.config,
            payload: { guestUpload: newVal },
        });
    }

    public startDelete(fileRecord: FileRecord) {
        this.fileRecordToDelete = fileRecord;
        this.deleteDialogActive = true;
    }

    public async onBeforeDelete(confirmation: boolean) {
        if (this.fileRecordToDelete) {
            const i: number = this.fileRecordsForUpload.indexOf(
                this.fileRecordToDelete
            );
            if (i !== -1) {
                this.fileRecordsForUpload.splice(i, 1);
            } else {
                if (confirmation) {
                    const fileAgent = (this.$refs
                        .vueFileAgent as unknown) as VueFileAgentComponent;
                    await fileAgent.deleteFileRecord(this.fileRecordToDelete); // will trigger 'delete' event
                }
                this.fileRecordToDelete = null;
                this.deleteDialogActive = false;
            }
        }
    }

    public filesSelected(fileRecordsNewlySelected: FileRecord[]) {
        const validFileRecords: FileRecord[] = fileRecordsNewlySelected.filter(
            fileRecord => !fileRecord.error
        );
        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
            validFileRecords
        );
        this.manualUpload();
    }

    public async manualUpload() {
        const fileAgent = (this.$refs
            .vueFileAgent as unknown) as VueFileAgentComponent;
        await fileAgent
            .upload(
                this.uploadUrl,
                this.uploadHeaders,
                this.fileRecordsForUpload
            )
            .then(() => {
                // const y = this.cleanFileRecords(this.fileRecordsForUpload);

                const y = this.fileRecordsForUpload;
                this.update({
                    config: this.config,
                    payload: { fileRecords: y },
                });
                this.fileRecordsForUpload = [];
            });
    }

    public async fileDeleted(fileRecord: FileRecord) {
        const i: number = this.fileRecordsForUpload.indexOf(fileRecord);
        if (i !== -1) {
            this.fileRecordsForUpload.splice(i, 1);
        } else {
            const fileAgent = (this.$refs
                .vueFileAgent as unknown) as VueFileAgentComponent;
            const uploadData = { someFileId: "123" };
            if (!fileRecord.error) {
                await fileAgent.deleteUpload(
                    fileRecord.urlValue || "",
                    this.uploadHeaders,
                    fileRecord,
                    uploadData
                );

                this.update({
                    config: this.config,
                    payload: { fileRecordToDelete: fileRecord },
                });
            }
        }
    }

    public cleanFileRecords(fileRecords: FileRecord[]): FileRecord[] {
        const x: FileRecord[] = [];
        fileRecords.forEach(fi => {
            try {
                if (fi.upload) {
                    if (fi.upload.data != null) {
                        if (fi.upload.data.id) {
                            fi.urlValue =
                                "/api/file/by_id/" + fi.upload.data.id || "";
                        }
                        fi.name = fi.upload.data.filename;
                        delete fi.file;
                        delete fi.progress;
                        delete fi.urlResized;
                        delete fi.color;
                    }
                }
                x.push(fi);
            } catch (e) {
                console.log("error", e);
            }
        });
        return x;
    }

    public get isPresenter(): boolean {
        return this.$store.getters.isPresenter;
    }

    public get limits(): { maxSize: string; maxFiles: number } {
        return { maxSize: "10MB", maxFiles: 5 };
    }
}
